import request from "@/utils/request";

export function getList(data) {
	return request({
		url: '/app/user/gongzi/list',
		method: 'post',
		data
	})
}